<template>
  <el-dialog
    title="订单详情"
    customClass="customWidth"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="10px"
      size="small"
    >
      订单详情
      <el-table
              :data="tableData"
              border
              style="width: 100%"
      >
        <el-table-column
                label="商铺名称"
                width="180"
        >
          <template slot-scope="scope">
            {{scope.row.agentname}}
          </template>
        </el-table-column>
        <el-table-column
                label="订单编号"
                :show-overflow-tooltip="true"
                width="150"
        >
          <template slot-scope="scope">
            {{scope.row.mer_order_id}}
          </template>
        </el-table-column>
        <el-table-column
                label="支付时间"
                :show-overflow-tooltip="true"
                width="150"
        >
          <template slot-scope="scope">
            {{scope.row.order_time2}}
          </template>
        </el-table-column>

        <el-table-column
                label="支付方式"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">

            <div v-if="scope.row.pay_type=='微信刷脸'">
              微信
            </div>
            <div v-else-if="scope.row.pay_type=='支付宝刷脸'">
              支付宝
            </div>
            <div v-else>
              {{scope.row.pay_type}}
            </div>

          </template>
        </el-table-column>
        <el-table-column
                label="会员头像"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">

          </template>
        </el-table-column>

        <el-table-column
                label="会员呢称"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">

          </template>
        </el-table-column>
        <el-table-column
                label="会员等级"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">

          </template>
        </el-table-column>

      </el-table>

      商品信息
      <el-table
              :data="tableData2"
              border
              show-summary
              :summary-method="getSummaries"
              style="width: 100%"
      >
        <el-table-column
                label="商品图片"
                width="180"
                prop="agentname"
        >
          <template slot-scope="scope">
            <img :src= "getImgUrl(scope.row)" style="width: 100px;height: 100px; "/>
          </template>
        </el-table-column>
        <el-table-column
                label="商品名称"
                :show-overflow-tooltip="true"
                width="150"
                prop="goodsname"
        >
          <template slot-scope="scope">
            {{scope.row.goodsname}}
          </template>
        </el-table-column>
        <el-table-column
                label="单价"
                :show-overflow-tooltip="true"
                width="150"
                prop="price"
        >
          <template slot-scope="scope">
            {{scope.row.price}}
          </template>
        </el-table-column>

        <el-table-column
                label="数量"
                :show-overflow-tooltip="true"
                prop="count_num"
        >
          <template slot-scope="scope">
            {{scope.row.count_num}}
          </template>
        </el-table-column>
        <el-table-column
                label="小计"
                :show-overflow-tooltip="true"
                prop="total_amount"
        >
          <template slot-scope="scope">
            {{scope.row.total_amount}}
          </template>
        </el-table-column>

      </el-table>

      费用信息
      <el-table
              :data="tableData"
              border
              style="width: 100%"
      >
        <el-table-column
                label="订单总金额"
                width="180"
        >
          <template slot-scope="scope">
            ￥{{scope.row.order_amt_total}}
          </template>
        </el-table-column>
        <el-table-column
                label="优惠券"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
          </template>
        </el-table-column>
        <el-table-column
                label="折扣"
                :show-overflow-tooltip="true"
                width="150"
        >
          <template slot-scope="scope">
          </template>
        </el-table-column>

        <el-table-column
                label="满减"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
          </template>
        </el-table-column>
        <el-table-column
                label="积分抵扣"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
          </template>
        </el-table-column>

        <el-table-column
                label="优惠金额合计"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            ￥{{scope.row.reduce_cost}}
          </template>
        </el-table-column>
        <el-table-column
                label="实付金额"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            ￥{{scope.row.order_amt}}
          </template>
        </el-table-column>

      </el-table>

      <el-form-item>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<style>
  .customWidth{
    width:80%;
  }
</style>
<script>
import * as agentService from '@/api/sys/agent'
export default {
  name: 'oneclassEditForm',
  props: {
    agent: Object,
    value: Boolean
  },
  data () {
    return {
      tableData: [],
      tableData2: [],
      loading: false,
      dialogVisible: false,
      dialogImageUrl: '',
      pickerOptions: {},
      form: {
        businessid: '',
        businessname: '',
        dateRange: []
      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    getImgUrl (row) {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + row.goodsimg
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 4) {
          const values = data.map(item => Number(item[column.property]))
          console.log('values========' + values)
          if (!values.every(value => isNaN(value))) {
            sums[index] = '合计：￥' + values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] += ' 元'
          } else {
            sums[index] = 'N/A'
          }
        }
      })

      return sums
    },
    dialogOpen () {
      this.$refs.form.resetFields()
      this.form = {}
      let countlistArray = []
      countlistArray.push(this.agent)
      this.tableData = countlistArray

      let query = {
        mer_order_id: this.agent.mer_order_id
      }
      agentService.getGoodOrderlist(query).then(data => {
        this.tableData2 = data
      })
    },
    // 上传文件之前的钩子
    handleBeforeUpload (file) {
      this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!')
      console.log('before')
      if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        this.$notify.warning({
          title: '警告',
          message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
        })
      }
      let size = file.size / 1024 / 1024 / 2
      if (size > 2) {
        this.$notify.warning({
          title: '警告',
          message: '图片大小必须小于2M'
        })
      }
    },
    // 文件超出个数限制时的钩子
    handleExceed (files, fileList) {

    },
    // 文件列表移除文件时的钩子
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    showToggle (val) {
      this.form.putobject = val
      if (val == 1) {
        this.typeone = true
        this.typetwo = false
        this.typethree = false
      } else if (val == 2) {
        this.typetwo = true
        this.typeone = false
        this.typethree = false
      } else if (val == 3) {
        this.typethree = true
        this.typetwo = false
        this.typeone = false
      }
    },
    showToggle2 (val) {
      this.form.putrange = val
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {

        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
